import Filters from '../../modules/components/Filters';

export default Filters;



// WEBPACK FOOTER //
// ./src/components/shared/Filters.js